import api from '../middleware/api'
import { actions } from 'redux-clerk2'
import * as notificationActions from './notifications'

const mainActions = actions({
  actionPrefix: 'SEMINAR_REQUESTS',
  uidField: 'id',
  actionSettings:{
	  default:{
		  url: `seminar_requests`
		  ,error: {
			  type: 'notification',
			  title: 'Oops! Something went wrong',
		      //message: 'Brace yourself till we get the error fixed. You may also refresh the page or try again later',
		      kind: 'error'
		  }
		//   ,notification: {
		// 	  //type: 'notification',
		// 	  title: 'Successfully saved!',
		//       //message: error.response.data.message,
		//       kind: 'success'
		//   }
		//   ,loading: 'Please wait while we are doing some work...'
	  }
  },
  api: api,
  notificationActions: notificationActions
})

export default mainActions